/**
 * CONFIGURADOR TREKKO — KIT PRIMEIROS ENCANTOS
 *
 * O Kit reune 4 pecas (Porta-Maternidade, Letreiro, Quadro Monograma e
 * Luminaria Balao) e o cliente faz TRES escolhas, cada uma com um alcance
 * diferente. Por isso o Kit tem motor proprio.
 *
 *   Passo 1 — Cor:     vale para as 4 pecas, pintando um elemento
 *                      diferente em cada uma
 *   Passo 2 — Inicial: a MESMA inicial vai nas 4 pecas
 *   Passo 3 — Nome:    vai em 3 pecas; a Luminaria Balao leva so a inicial
 *
 * VARIANTES: option1 = "Cor do kit", option2 = "Inicial".
 *
 * O QUE VIRA PROPERTY
 * So o que a variante NAO carrega. Cor e Inicial ja aparecem no titulo da
 * variante ("Rose / H"); repetir como property faz o carrinho mostrar a
 * mesma escolha duas vezes. O NOME nunca esta na variante — texto livre
 * nao cabe em opcao — entao ele e sempre gravado. Sem variantes
 * (temVariantes = false), gravamos tudo: a property vira a unica fonte.
 */
(function () {
  'use strict';

  var cfg = window.TREKKO_KIT_CFG || {};
  var maxNome = parseInt(cfg.maxNome, 10) || 12;
  var temVariantes = cfg.temVariantes === true;
  var variantMap = window.TREKKO_KIT_VARIANTS || {};

  var props = cfg.props || {};
  var pCor = props.cor || 'Cor';
  var pInicial = props.inicial || 'Inicial';
  var pNome = props.nome || 'Nome';

  var estado = { cor: null, inicial: null, nome: '' };

  /* ---- helpers ---- */

  function getEtapa(n) {
    return document.querySelectorAll('.ac-etapa')[n - 1];
  }

  function setHeader(etapa, texto) {
    if (!etapa) return;
    var el = etapa.querySelector('.ac-etapa-valor');
    if (el) el.textContent = texto || '';
  }

  function getForm() {
    return document.querySelector('form.product-form') ||
           document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[id^="ProductForm"]');
  }

  function setProp(form, nome, valor) {
    var existente = form.querySelector('[name="properties[' + nome + ']"]');
    if (existente) existente.parentNode.removeChild(existente);
    if (!valor) return;
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = 'properties[' + nome + ']';
    inp.value = valor;
    form.appendChild(inp);
  }

  function injetarPropriedades() {
    var form = getForm();
    if (!form) return;

    /* Cor e Inicial: so quando NAO ha variante para carrega-las. */
    setProp(form, pCor, temVariantes ? null : estado.cor);
    setProp(form, pInicial, temVariantes ? null : estado.inicial);

    /* Nome: sempre. Nunca esta na variante. */
    setProp(form, pNome, estado.nome);
  }

  /* ---- ponte com os seletores nativos (option1 = Cor, option2 = Inicial) ---- */
  function setNativeOption(pos, value) {
    if (value == null) return false;
    var nodes = document.querySelectorAll('[name^="options"][data-index="option' + pos + '"]');
    if (!nodes.length) return false;

    if (nodes.length === 1) {
      nodes[0].value = value;
      nodes[0].dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var achou = false;
    nodes.forEach(function (n) {
      if (n.value === value) {
        n.checked = true;
        n.dispatchEvent(new Event('change', { bubbles: true }));
        achou = true;
      } else {
        n.checked = false;
      }
    });
    return achou;
  }

  function selecionarVariante() {
    if (!temVariantes) return;
    if (estado.cor) setNativeOption(1, estado.cor);
    if (estado.inicial) setNativeOption(2, estado.inicial);
    if (estado.cor && estado.inicial) {
      var id = variantMap[estado.cor + '|' + estado.inicial];
      if (id) {
        var idInput = document.querySelector('[name="id"]');
        if (idInput && idInput.value !== String(id)) idInput.value = id;
      }
    }
  }

  function atualizarResumo() {
    function set(key, val) {
      var linha = document.querySelector('[data-resumo="' + key + '"]');
      var elVal = linha && linha.querySelector('.ac-resumo-val');
      if (!linha || !elVal) return;
      if (val) {
        elVal.textContent = val;
        linha.classList.remove('ac-resumo-pendente');
      } else {
        elVal.textContent = '---';
        linha.classList.add('ac-resumo-pendente');
      }
    }
    set('cor', estado.cor);
    set('inicial', estado.inicial);
    set('nome', estado.nome);
  }

  function revelar(etapa) {
    if (!etapa) return;
    var eraInvisivel = !etapa.classList.contains('ac-visivel');
    etapa.classList.add('ac-visivel');
    if (eraInvisivel) {
      setTimeout(function () {
        etapa.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 80);
    }
  }

  function atualizar() {
    setHeader(getEtapa(1), estado.cor);
    setHeader(getEtapa(2), estado.inicial);
    setHeader(getEtapa(3), estado.nome);

    if (estado.cor) revelar(getEtapa(2));
    if (estado.cor && estado.inicial) revelar(getEtapa(3));

    atualizarResumo();
    selecionarVariante();
    injetarPropriedades();
  }

  /* ---- Passo 1: Cor ---- */
  document.querySelectorAll('.ac-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ac-swatch').forEach(function (b) { b.classList.remove('ac-sel'); });
      this.classList.add('ac-sel');
      estado.cor = this.dataset.cor;
      var e1 = getEtapa(1);
      if (e1) e1.classList.remove('ac-destaque');
      atualizar();
    });
  });

  /* ---- Passo 2: Inicial ---- */
  document.querySelectorAll('.ac-btn-letra').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ac-btn-letra').forEach(function (b) { b.classList.remove('ac-sel'); });
      this.classList.add('ac-sel');
      estado.inicial = this.dataset.letra;
      var e2 = getEtapa(2);
      if (e2) e2.classList.remove('ac-destaque');
      atualizar();
    });
  });

  /* ---- Passo 3: Nome ---- */
  var inpNome = document.querySelector('.ac-input-nome');
  var contador = document.querySelector('.ac-contador');

  function pintarContador() {
    if (!contador) return;
    contador.textContent = estado.nome.length + '/' + maxNome;
    if (estado.nome.length >= maxNome) {
      contador.classList.add('ac-cheio');
    } else {
      contador.classList.remove('ac-cheio');
    }
  }

  if (inpNome) {
    inpNome.setAttribute('maxlength', maxNome);
    inpNome.addEventListener('input', function () {
      var v = this.value.toUpperCase().replace(/[^A-ZÀ-Ü ]/g, '');
      v = v.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
      if (v.length > maxNome) v = v.substring(0, maxNome);
      this.value = v;
      estado.nome = v.trim();
      var etapa = this.closest('.ac-etapa');
      if (etapa) etapa.classList.remove('ac-destaque');
      pintarContador();
      atualizar();
    });
    inpNome.addEventListener('blur', function () {
      this.value = this.value.trim();
      estado.nome = this.value;
      pintarContador();
      atualizar();
    });
    pintarContador();
  }

  /* ---- Reabrir etapa ---- */
  document.querySelectorAll('.ac-etapa-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var etapa = this.closest('.ac-etapa');
      if (etapa) etapa.classList.remove('ac-concluida');
    });
  });

  /* ---- Proteger botao de compra ---- */
  function interceptarCompra(e) {
    var faltando = null;
    if (!estado.cor) faltando = getEtapa(1);
    else if (!estado.inicial) faltando = getEtapa(2);
    else if (!estado.nome) faltando = getEtapa(3);

    if (!faltando) {
      selecionarVariante();
      injetarPropriedades();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    faltando.classList.add('ac-visivel');
    faltando.scrollIntoView({ behavior: 'smooth', block: 'center' });
    faltando.classList.add('ac-destaque');
    setTimeout(function () { faltando.classList.remove('ac-destaque'); }, 1800);
  }

  function bindBtnCompra() {
    var btns = document.querySelectorAll('[name="add"], [data-add-to-cart], .js-addtocart, button[data-action="add-to-cart"]');
    btns.forEach(function (btn) {
      if (!btn.dataset.acBound) {
        btn.dataset.acBound = '1';
        btn.addEventListener('click', interceptarCompra, true);
      }
    });
  }
  bindBtnCompra();
  setTimeout(bindBtnCompra, 500);
  setTimeout(bindBtnCompra, 1200);

  /* ---- Inicializacao ---- */
  var primeira = document.querySelector('.ac-etapa');
  if (primeira) primeira.classList.add('ac-visivel');
  atualizarResumo();

})();